import React from "react";
import { Link } from "react-router-dom";
import BusinessLayout from "../../layouts/BusinessLayout";
import ProductsSection from "../../components/organization/ProductsSection";

const BusinessProductsCatalog: React.FC = () => {
  return (
    <BusinessLayout>
      {(business) => <ProductsSection business={business} LinkComponent={Link} />}
    </BusinessLayout>
  );
};

export default BusinessProductsCatalog;
